import token, { tokenToVars } from '../token';
import Link from './link';

export { Link };
export default tokenToVars(Link, token);
